import Actions                   from 'Redux/Actions';
import { ofType }                from 'redux-observable';
import { from }                  from 'rxjs';
import { mergeMap, catchError }  from 'rxjs/operators';
import { TEpic }                 from 'Redux/Config';
import { EventTicketRepository } from 'Domain/Repositories';
import { message }               from 'antd';

export const createEventTicketEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createEventTicketRequest.type),
    mergeMap(action => from(EventTicketRepository.create(action.payload.formData))
      .pipe(
        mergeMap((eventTicket) => {
          message.success('Event Ticket wurde erfolgreich erstellt');
          return from([
            Actions.createEventTicketSuccess({ eventTicket })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createEventTicketFailure({ error }),
          ]);
        })
      )
    ),
  );
};
